import {fromJS, Map} from 'immutable';
import isEmpty from 'lodash.isempty';
import oauthActions from '../actions/oauth.actions';
import dieselReducer from 'epic-diesel-common/src/decorators/DieselReducer';
import {AuthedPage, SocialPlatform} from '../../shared/types';

export interface OAuth {
    redirectUrl?: string;
    platform: SocialPlatform;
    state: string;
    errors?: string[];
    pages?: AuthedPage[];
}

export interface OAuthState {
    oauth: Record<SocialPlatform, OAuth>;
    loading: boolean;
}

export const DEFAULT_STATE = fromJS({
    oauth: {},
    loading: false
});

export const oauthReducer = (state: Map<keyof OAuthState, any> = DEFAULT_STATE, action) => {
    let newState = state;
    switch (action.type) {
        /**
         * FETCH oauth link
         */
        case oauthActions.TYPES.GET_OAUTH_LINK: {
            return state.updateIn(['loading'], () => true);
        }
        case oauthActions.TYPES.GET_OAUTH_LINK_COMPLETE: {
            const {data: authLink} = action.payload || {};
            if (!isEmpty(authLink)) {
                newState = newState.updateIn(['oauth', authLink.platform], () => authLink);
            }
            newState = newState.updateIn(['loading'], () => false);
            return newState;
        }
        case oauthActions.TYPES.GET_OAUTH_LINK_FAILED: {
            return state.updateIn(['loading'], () => false);
        }

        /**
         * FETCH oauth
         */
        case oauthActions.TYPES.GET_OAUTH: {
            return state.updateIn(['loading'], () => true);
        }
        case oauthActions.TYPES.GET_OAUTH_COMPLETE: {
            const {data: oauth} = action.payload || {};
            if (!isEmpty(oauth)) {
                newState = newState.updateIn(['oauth', oauth.platform], () => oauth);
            }
            newState = newState.updateIn(['loading'], () => false);
            return newState;
        }
        case oauthActions.TYPES.GET_OAUTH_FAILED: {
            return state.updateIn(['loading'], () => false);
        }

        /**
         * RESET oauth state
         */
        case oauthActions.TYPES.RESET_OAUTH: {
            const {platform} = action.payload || {};
            if (!isEmpty(newState.getIn(['oauth', platform]))) {
                newState = newState.deleteIn(['oauth', platform]);
            }
            return newState;
        }

        /**
         * DEFAULT STATE
         */
        default:
            return state;
    }
};

export default dieselReducer('oauth', oauthReducer);
